import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
    selector: 'gd-type-editor-pro-type',
    templateUrl: './type-editor-pro-type.component.html',
    styleUrls: ['./type-editor-pro-type.component.scss'],
    imports: [
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
            KENDO_DROPDOWNS,
            KENDO_GRID,
            KENDO_INPUTS,
            KENDO_GRID_PDF_EXPORT,
            KENDO_GRID_EXCEL_EXPORT,
            KENDO_INDICATORS,
            KENDO_DIALOGS, KENDO_BUTTONS,
            CommonModule
    ]
})
export class TypeEditorProTypeComponent extends GridEditorBaseComponent {
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getProTypes().subscribe((response) => {
      this.repState.proTypes = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const proType = formGroup.value
    this.typesService.submitProTypeUpdate(proType).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        proTypeId: 0,
        proTypeDescription: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(proType: any): UntypedFormGroup {
    return this.formBuilder.group({
      proTypeId: proType.proTypeId,
      proTypeDescription: [proType.proTypeDescription, Validators.required],
      active: proType.active,
    })
  }
}
